import { initialStateForCampaignSlice } from "../pages/campaigns/campaignSlice";
import { initialStateForWishlistSlice } from "../pages/company-wishlist/wishlistSlice";
import { initialStateForDashboardSlice } from "../pages/dashboard/dashboardSlice";
import { initialStateForCommonSlice } from "./commonSlice";
export const migrations = {
  0: (state) => state, // default, no change
  1: (state) => {
    return {
      ...state,
      campaignSlice: initialStateForCampaignSlice, // Reset this slice
      // Only reset slices if you changed their shape
      dashboardSlice: initialStateForDashboardSlice,
      commonSlice: initialStateForCommonSlice,
      wishlistSlice: initialStateForWishlistSlice,
    };
  },
  // v2 blobs predate fields such as campaignSlice.allStatusCount; the default
  // autoMergeLevel1 reconciler swaps the whole slice in, so the missing keys read
  // as undefined and crash the campaign pages. Reset the reshaped slices.
  2: (state) => {
    return {
      ...state,
      campaignSlice: initialStateForCampaignSlice,
      dashboardSlice: initialStateForDashboardSlice,
      commonSlice: initialStateForCommonSlice,
      wishlistSlice: initialStateForWishlistSlice,
    };
  },
  // Add future versions here
};